import {registrationApi} from 'common/api/entitiesApi'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import './style.css'
import {Button, Form, Input, Layout, message} from 'antd';
import {LockOutlined} from '@ant-design/icons';
import { useUserContext } from 'common/context/UserContext'
import { CommonRoutes } from 'common/context/commonRoutes.ts'

const FormItem = Form.Item

interface Props {
    title: string
}

export const CreatePasswordForm: React.FC<Props> = ({title}) => {

    const [form] = Form.useForm();
    const navigateTo = useNavigate()
    const params = useParams<{ email: string; role: string; token: string }>()
    const [messageApi, contextHolder] = message.useMessage();
    const [error, setError] = useState<string | undefined>(undefined);
    const { logoDataURI } = useUserContext()

    const handleSubmit = () => {
        form.validateFields().then(formValues => {
            registrationApi.registerPassword({...formValues, email: params.email, token: params.token})
                .then(({passwordNotStrong, alreadyRegistered, success, passwordNotMatch, accountNotFound}) => {
                    if (passwordNotStrong) {
                        setError('Password is not strong enough')
                        return
                    }
                    if (passwordNotMatch) {
                        setError('Password is not match')
                        return
                    }
                    if (accountNotFound) {
                        setError('Account not found')
                        return
                    }
                    if (alreadyRegistered) {
                        setError('User with this email is already registered')
                        return
                    }
                    if (success) {
                        navigateTo(CommonRoutes.LOGIN)
                        return
                    }
                    setError('Something went wrong, try again later')
                }).catch(response => {
                setError(response.error)
            })
        })
    }

    const errorMessage = () => {
        messageApi.open({
            type: 'error',
            content: error,
            duration: 5,
            style: {
                marginTop: '80px',
            },
        });
    };

    useEffect(() => {
        if (error) {
            errorMessage()
            setError(undefined);
        }
    }, [error]);

    return (
        <Layout>
            {contextHolder}
            {logoDataURI && (
                <div className="auth-logo-wrapper">
                    <img src={logoDataURI} alt="Logo" className="auth-logo" />
                </div>
            )}

            <Form
                form={form}
                onFinish={handleSubmit}
                className="password-form"
            >
                <FormItem
                    name="password"
                    rules={[
                        {required: true, message: 'Please input your Password!'},
                    ]}
                >
                    <Input.Password prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                                    placeholder="Password"/>
                </FormItem>
                <FormItem
                    name="passwordConfirm"
                    rules={[
                        {required: true, message: 'Please input Password Confirm!'},
                    ]}>
                    <Input.Password prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                                    placeholder="Confirm Password"/>
                </FormItem>
                <FormItem
                >
                    <Button type="primary" htmlType="submit" className="password-form-button">
                        {title}
                    </Button>
                </FormItem>
            </Form>
        </Layout>
    )
}
